import {
  DO_CREATE_DOMAIN_START,
  DO_CREATE_DOMAIN_SUCCESS,
  DO_CREATE_DOMAIN_FAIL,
  DO_UPDATE_DOMAIN_START,
  DO_UPDATE_DOMAIN_SUCCESS,
  DO_UPDATE_DOMAIN_FAIL,
  DO_JOIN_OTHER_DOMAIN_START,
  DO_JOIN_OTHER_DOMAIN_SUCCESS,
  DO_JOIN_OTHER_DOMAIN_FAIL,
  DO_APPROVE_DOMAIN_REQUEST_START,
  DO_APPROVE_DOMAIN_REQUEST_SUCCESS,
  DO_APPROVE_DOMAIN_REQUEST_FAIL,
  DO_GET_DOMAIN_REQUESTORS_START,
  DO_GET_DOMAIN_REQUESTORS_SUCCESS,
  DO_GET_DOMAIN_REQUESTORS_FAIL,
  DO_GET_DOMAINS_BY_USER_ID_START,
  DO_GET_DOMAINS_BY_USER_ID_SUCCESS,
  DO_GET_DOMAINS_BY_USER_ID_FAIL,
  DO_GET_OTHER_DOMAINS_BY_USER_ID_START,
  DO_GET_OTHER_DOMAINS_BY_USER_ID_SUCCESS,
  DO_GET_OTHER_DOMAINS_BY_USER_ID_FAIL,
  DO_START_USER_DOMAIN_START,
  DO_START_USER_DOMAIN_SUCCESS,
  DO_START_USER_DOMAIN_FAIL,
  DO_SET_DOMAIN_INFO_MANUALLY,
  DO_REMOVE_DOMAIN_INFO,
  DO_INVITE_USER_TO_DOMAIN_START,
  DO_INVITE_USER_TO_DOMAIN_SUCCESS,
  DO_INVITE_USER_TO_DOMAIN_FAIL,
  DO_GET_JOINED_DOMAINS_BY_USER_ID_START,
  DO_GET_JOINED_DOMAINS_BY_USER_ID_SUCCESS,
  DO_GET_JOINED_DOMAINS_BY_USER_ID_FAIL,
} from '../actionTypes/domain'

// The initial state of the App
export const initialState = {
  isLoading: false,
  currentDomain: null,
  myDomains: [],
  otherDomains: [],
  joinedDomains: [],
  subdomain: null,
  domainRequestors: []
}

const domain = (state = initialState, action) => {
  switch (action.type) {
    case DO_CREATE_DOMAIN_START:
      return {
        ...state,
        isLoading: true,
      };
    case DO_CREATE_DOMAIN_SUCCESS:
      const newMyDomains = state.myDomains.slice()
      newMyDomains.push({
        ...action.data?.userRole,
        ...action.data?.domain,
        userRoleId: action.data?.userRole?.id,
      })
      return {
        ...state,
        isLoading: false,
        myDomains: newMyDomains
      };
    case DO_CREATE_DOMAIN_FAIL:
      return {
        ...state,
        isLoading: false,
      };
    case DO_UPDATE_DOMAIN_START:
      return {
        ...state,
        isLoading: true,
      };
    case DO_UPDATE_DOMAIN_SUCCESS:
      const tmpDomains = JSON?.parse(JSON?.stringify(state.myDomains))
      const { domainId, ...tmpDomainInfo } = action.data
      if (domainId) {
        const domainIndex = tmpDomains.findIndex(domain => domain.domainId === domainId)
        if (domainIndex !== -1) {
          tmpDomains[domainIndex] = {
            ...tmpDomains[domainIndex],
            ...tmpDomainInfo,
          }
        }
      }
      return {
        ...state,
        isLoading: false,
        myDomains: tmpDomains || [],
      };
    case DO_UPDATE_DOMAIN_FAIL:
      return {
        ...state,
        isLoading: false,
      };
    case DO_JOIN_OTHER_DOMAIN_START:
      return {
        ...state,
        isLoading: true,
      }
    case DO_JOIN_OTHER_DOMAIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
      }
    case DO_JOIN_OTHER_DOMAIN_FAIL:
      return {
        ...state,
        isLoading: false,
      }
    case DO_APPROVE_DOMAIN_REQUEST_START:
      return {
        ...state,
        isLoading: true,
      }
    case DO_APPROVE_DOMAIN_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
      }
    case DO_APPROVE_DOMAIN_REQUEST_FAIL:
      return {
        ...state,
        isLoading: false,
      }
    case DO_GET_DOMAIN_REQUESTORS_START:
      return {
        ...state,
        isLoading: true,
      }
    case DO_GET_DOMAIN_REQUESTORS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        domainRequestors: action.data,
      }
    case DO_GET_DOMAIN_REQUESTORS_FAIL:
      return {
        ...state,
        isLoading: false,
        domainRequestors: [],
      }
    case DO_GET_DOMAINS_BY_USER_ID_START:
      return {
        ...state,
        isLoading: true,
      }
    case DO_GET_DOMAINS_BY_USER_ID_SUCCESS:
      const tmpMyDomains = action.data && action.data.length > 0 && action.data.map(domain => ({
        userRoleId: domain?.id,
        userId: domain?.userId,
        roleId: domain?.roleId,
        domainId: domain?.domainId,
        isOwner: domain?.isOwner,
        ownerName: domain?.user?.firstname + ' ' + domain?.user?.lastname,
        role: domain?.role,
        ...domain?.domain,
      }))
      return {
        ...state,
        isLoading: false,
        myDomains: tmpMyDomains || []
      }
    case DO_GET_DOMAINS_BY_USER_ID_FAIL:
      return {
        ...state,
        isLoading: false,
      }
    case DO_GET_OTHER_DOMAINS_BY_USER_ID_START:
      return {
        ...state,
        isLoading: true,
      }
    case DO_GET_OTHER_DOMAINS_BY_USER_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        otherDomains: action.data
      }
    case DO_GET_OTHER_DOMAINS_BY_USER_ID_FAIL:
      return {
        ...state,
        isLoading: false,
      }
    case DO_START_USER_DOMAIN_START:
      return {
        ...state,
        isLoading: true,
      }
    case DO_START_USER_DOMAIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        currentDomain: {
          ...action.data.domain.domain,
          roleName: action.data.domain?.userRole?.role?.name,
          userRoleId: action.data.domain?.userRole?.id,
          isOwner: action.data.domain?.userRole?.isOwner,
          roleId: action.data.domain?.userRole?.role?.id,
        },
        subdomain: action.data.subdomain
      }
    case DO_START_USER_DOMAIN_FAIL:
      return {
        ...state,
        isLoading: false,
      }
    case DO_SET_DOMAIN_INFO_MANUALLY:
      return {
        ...state,
        currentDomain: action.data.currentDomain,
        subdomain: action.data.subdomain,
      }
    case DO_REMOVE_DOMAIN_INFO:
      return {
        ...state,
        currentDomain: null,
        subdomain: null,
      }
    case DO_INVITE_USER_TO_DOMAIN_START:
      return {
        ...state,
        isLoading: true,
      }
    case DO_INVITE_USER_TO_DOMAIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
      }
    case DO_INVITE_USER_TO_DOMAIN_FAIL:
      return {
        ...state,
        isLoading: false,
      }
    case DO_GET_JOINED_DOMAINS_BY_USER_ID_START:
      return {
        ...state,
        isLoading: true,
      }
    case DO_GET_JOINED_DOMAINS_BY_USER_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        joinedDomains: action.data
      }
    case DO_GET_JOINED_DOMAINS_BY_USER_ID_FAIL:
      return {
        ...state,
        isLoading: false,
        joinedDomains: [],
      }
    default:
      return state
  }
}

export default domain
